import { type Locale, PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { ROUTE_PERMISSIONS } from '~/shared/permissions/route-permissions';

type NavigationZoneParams = Readonly<{
  lng: Locale;
  isPlatform: boolean;
  isAdminPanel: boolean;
}>;

type NavigationAccessConfig = Readonly<{
  profileLink: string;
  dialogsLink: string;
  profilePermission: string;
  dialogsPermission: string;
}>;

export const getNavigationAccessConfig = ({
  lng,
  isPlatform,
  isAdminPanel,
}: NavigationZoneParams): NavigationAccessConfig => {
  if (isPlatform) {
    return {
      profileLink: getLocaleLink(PAGE_NAMES.PLATFORM_USER_PROFILE, lng),
      dialogsLink: getLocaleLink(PAGE_NAMES.PLATFORM_USER_DIALOGS, lng),
      profilePermission: ROUTE_PERMISSIONS[PAGE_NAMES.PLATFORM_USER_PROFILE],
      dialogsPermission: ROUTE_PERMISSIONS[PAGE_NAMES.PLATFORM_USER_DIALOGS],
    };
  }

  if (isAdminPanel) {
    return {
      profileLink: getLocaleLink(PAGE_NAMES.ADMIN_USER_PROFILE, lng),
      dialogsLink: getLocaleLink(PAGE_NAMES.ADMIN_USER_DIALOGS, lng),
      profilePermission: ROUTE_PERMISSIONS[PAGE_NAMES.ADMIN_USER_PROFILE],
      dialogsPermission: ROUTE_PERMISSIONS[PAGE_NAMES.ADMIN_USER_DIALOGS],
    };
  }

  return {
    profileLink: getLocaleLink(PAGE_NAMES.USER_PROFILE, lng),
    dialogsLink: getLocaleLink(PAGE_NAMES.USER_DIALOGS, lng),
    profilePermission: ROUTE_PERMISSIONS[PAGE_NAMES.USER_PROFILE],
    dialogsPermission: ROUTE_PERMISSIONS[PAGE_NAMES.USER_DIALOGS],
  };
};
